import React from "react";
import { StldCardTableAtividadesOptions } from "../../styled-components/StyledCardTableAtividadesOptions.style";
import { IconMenuDotsV } from "../../svg";
import Flex from '@react-css/flex';

export const CardTableAtividadesOptions = (props) => {
    const {
        item,
        getCardId = { getCardId },
        openCancelModal = { openCancelModal },
        openModalItemAtividadeTimesheetHistoricoIsOpen = { openModalItemAtividadeTimesheetHistoricoIsOpen },
        openEditModal = { openEditModal },
        openNotifyModal = { openNotifyModal },
        openNotifyHistoricoModal = { openNotifyHistoricoModal },
        canEdit
    } = props;


    const convertDecimalToTime = (decValue) => {
        if (!decValue) {
            return;
        }

        const decimalHours = parseFloat(decValue?.replace(',', '.'));
        const hours = Math.floor(decimalHours);
        const minutes = Math.round((decimalHours - hours) * 60);
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}`;
    }

    const corLinha = (row) => {
        var className = ""
        switch(row.status) {
            case 'Notificado':
                className = 'table-data-info-warning'
                break;
            case 'Cancelado':
                className = 'table-data-info-canceled'
                break;
            default:
                if(row.proBono)
                    className = 'table-data-info-pro-bono'
                else
                    className = 'table-data-info'            
        }

        return className;
    }

    return (
        <StldCardTableAtividadesOptions className={corLinha(item)}>
            <Flex onMouseOut={() => getCardId(item.idTimesheetItemAtividade)} onMouseOver={() => getCardId(item.idTimesheetItemAtividade)}>
                <Flex.Item className="card-menu-title">
                </Flex.Item>
                <Flex.Item className="card-menu-title-left">
                    <ul id={item.idTimesheetItemAtividade} className="card-menu-hide">
                        {item.actions.detalhes ?
                            <li className="menu-card" onClick={() => openModalItemAtividadeTimesheetHistoricoIsOpen(item)}>Histórico</li> : null
                        }
                        {(item.actions.notificado || item.actions.editar && canEdit) && item.status !== 'Cancelado' ?
                            <li className="menu-card" onClick={() => openEditModal(item)}>Editar</li> : null
                        }
                        {item.actions.cancelar && canEdit && item.status !== 'Cancelado' ?
                            <li className="menu-card" onClick={() => openCancelModal(item.idTimesheetItemAtividade)}>Cancelar</li> : null
                        }
                        {item.actions.notificar && item.status !== 'Cancelado' &&
                            <li className="menu-card" onClick={() => openNotifyModal(item.idTimesheetItemAtividade)}>Notificar</li>
                        }
                        {item.status !== 'Cancelado' &&
                            <li className="menu-card" onClick={() => openNotifyHistoricoModal(item)}>Notificações</li>
                        }
                    </ul>
                </Flex.Item>
            </Flex>
            <div className="card-align">
                <Flex style={{ height: "20%" }}>
                    <Flex.Item className="flex-title-left">
                        <span className="title-card" title={item.atividade}>{item.atividade} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-title-text-right">
                        {(() => {
                            if (item.status === "Ativo") {
                                return (
                                    <span className="btn btn-success legend-title-text-bold">{item.status}</span>
                                )
                            } else if (item.status === "Cancelado") {
                                return (
                                    <span className="btn btn-danger legend-title-text-bold">{item.status}</span>
                                )
                            } else {
                                return (
                                    <span className="btn btn-warning legend-title-text-bold">{item.status}</span>
                                )
                            }
                        })()}
                    </Flex.Item>
                    <Flex.Item className="flex-column-title-right">
                        <span>
                            <button className="button-icon" onMouseOut={() => getCardId(item.idTimesheetItemAtividade)} onMouseOver={() => getCardId(item.idTimesheetItemAtividade)}><IconMenuDotsV /></button>
                        </span>
                    </Flex.Item>
                </Flex>
                <Flex style={{ height: "10%" }}>
                    <Flex.Item className="legend-description"
                        style={{ height: "20px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                        <span title={item.descricao}> {item.descricao} </span>
                    </Flex.Item>
                </Flex>
                <Flex style={{ height: "10%" }}>
                    <Flex.Item className="legend-description">
                        <span className="legend-time"> {item.datalancamento} </span>
                    </Flex.Item>
                </Flex>
                <Flex style={{ height: "5%" }}>
                    <Flex.Item className="flex-column-left">
                        <span className="details"> Inicio </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="details"> Término </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="details"> Intervalo </span>
                    </Flex.Item>
                </Flex>
                <Flex style={{ height: "10%" }}>
                    <Flex.Item className="flex-column-left">
                        <span className="time"> {item.periodoInicio} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="time">{item.periodoFim}</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="time">{convertDecimalToTime(item.intervaloHoras)}</span>
                    </Flex.Item>
                </Flex>
                <Flex style={{ height: "5%" }}>
                    <Flex.Item className="flex-column-left">
                        <span className="time"> {item.baseHoras} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-value-sub-value legend-value-nowrap">{item.valorHoraBase}</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-value legend-value-nowrap"> {item.totalValorFaturado}</span>
                    </Flex.Item>
                </Flex>
                <Flex style={{ height: "10%" }}>
                    <Flex.Item className="flex-column-left">
                        <span className="details"> Horas Lançadas </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="details"> Valor Hora </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="details"> Valor Total </span>
                    </Flex.Item>
                </Flex>
                <br />
                <Flex style={{ height: "5%" }}>
                    <Flex.Item className="flex-column-center">
                        <span className="name-info">&nbsp;{item.peritoNome}&nbsp;</span>
                    </Flex.Item>
                </Flex>
            </div>
        </StldCardTableAtividadesOptions>
    );
};
